import { defineMessages } from 'react-intl';

type MessageKeys = 'createAgentRefreshButton' | 'closeButton' | 'createButtonDisabledTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createAgentRefreshButton: {
			id: 'rovo-chat.browse-agents-header-refresh.create-agent-button-label',
			defaultMessage: 'Create agent',
			description: 'Button to create a new agent, shown in the refreshed header',
		},
		closeButton: {
			id: 'rovo-chat.browse-agents-header-refresh.close-button',
			defaultMessage: 'Close',
			description: 'Button to close the browse agents experience',
		},
		createButtonDisabledTooltip: {
			id: 'rovo-chat.browse-agents-header-refresh.create-button-disabled-tooltip',
			defaultMessage: "You don't have permission to create agents in this site",
			description:
				'Tooltip to show when the create agent button is disabled due to user not having rovo agent create permissions on the site',
		},
	});

export default message;
